{
  "nl": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bevestiging verstuurd op",
          "confirmation_token": "Bevestigingstoken",
          "confirmed_at": "Bevestigd op",
          "created_at": "Aangemaakt op",
          "current_password": "Huidig wachtwoord",
          "current_sign_in_at": "Huidige login op",
          "current_sign_in_ip": "Huidige login IP",
          "email": "E-mailadres",
          "encrypted_password": "Versleuteld wachtwoord",
          "failed_attempts": "Mislukte pogingen",
          "last_sign_in_at": "Laatste login op",
          "last_sign_in_ip": "Laatste login IP",
          "locked_at": "Vergrendeld op",
          "password": "Wachtwoord",
          "password_confirmation": "Bevestig wachtwoord",
          "remember_created_at": "Herinneren aangemaakt op",
          "remember_me": "Ingelogd blijven",
          "reset_password_sent_at": "Reset wachtwoord verstuurd op",
          "reset_password_token": "Reset wachtwoord token",
          "sign_in_count": "Aantal logins",
          "unconfirmed_email": "Onbevestigd e-mailadres",
          "unlock_token": "Ontgrendel token",
          "updated_at": "Bijgewerkt op"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validatie mislukt: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan item niet verwijderen omdat afhankelijke %{record} bestaan",
            "has_one": "Kan item niet verwijderen omdat %{record} afhankelijk is"
          }
        }
      },
      "models": {
        "user": {
          "one": "Gebruiker",
          "other": "Gebruikers"
        }
      }
    },
    "api": {
      "consultation_reminders": {
        "calendar_invite_summary": "Afspraak bij %{office}",
        "default_confirmation_subject": "Afspraakbevestiging",
        "default_confirmation_template": "<p>Beste @mention{patient_first_name}, </p><p></p><p>Hierbij bevestigen we jouw afspraak bij %{office} op @mention{consultation_date} om @mention{consultation_hour}.</p><p></p><p>Met vriendelijke groet, </p><p>%{office}</p>",
        "default_reminder_subject": "Afspraakherinnering",
        "default_reminder_template": "<p>Beste @mention{patient_first_name}, </p><p></p><p>Wij wensen je graag te herinneren aan jouw afspraak bij %{office} op @mention{consultation_date} om @mention{consultation_hour}.</p><p></p><p>Met vriendelijke groet, </p><p>%{office}</p>"
      },
      "forms": {
        "address": {
          "bus": "Bus",
          "city": "Stad",
          "country": "Land",
          "house_number": "Huisnummer",
          "input_address": "Hier kan je het adres opzoeken",
          "postal_code": "Postcode",
          "street": "Straat",
          "title": "Adres"
        },
        "billing_plan": {
          "active": "Actief",
          "kind": "Type",
          "name": "Naam",
          "params": "Parameters"
        },
        "billing_subscription": {
          "billable_id": "Klant",
          "billable_type": "Type klant",
          "billing_address": "Facturatieadres",
          "billing_email": "Facturatie e-mail",
          "billing_vat_id": "BTW-nummer",
          "deliver_via_peppol": "Bezorgen via Peppol",
          "ends_on": "Einddatum",
          "peppol_id": "Peppol ID",
          "plan_id": "Abonnement",
          "starts_on": "Startdatum",
          "status": "Status",
          "trial_ends_on": "Einde proefperiode"
        },
        "billing_supplier_config": {
          "address_line": "Adres",
          "city": "Stad",
          "country_code": "Landcode",
          "email": "E-mail",
          "enterprise_number": "Ondernemingsnummer",
          "iban": "IBAN",
          "invoice_conditions": "Betalingsvoorwaarden",
          "invoice_message": "Mededeling op factuur",
          "name": "Naam onderneming",
          "peppol_id": "Peppol ID",
          "peppyrus_api_key": "Peppyrus API Key",
          "phone": "Telefoon",
          "postal_code": "Postcode",
          "vat_id": "BTW-nummer"
        },
        "calendar": {
          "calendar_identification": "Agenda",
          "calendar_type": "Type",
          "color": "Kleur"
        },
        "consultation": {
          "consultation_type_id": "Type",
          "date": "Datum",
          "dossier_id": "Cliënt",
          "location_id": "Locatie",
          "no_invoice": "Niet factureren",
          "practioner": "Zorgverlener"
        },
        "consultation_price": {
          "blank_option": "(Alle)",
          "consultation_type": "Consultatietype",
          "consultation_type_id": "Consultatietype",
          "end_date": "Einddatum",
          "location": "Prakijk",
          "location_id": "Locatie",
          "practioner": "Zorgverlener",
          "practioner_id": "Zorgverlener",
          "price": "Prijs",
          "start_date": "Startdatum",
          "title": "Tarieven"
        },
        "consultation_reminder": {
          "email_template": "Email-template",
          "minutes_notice": "Wanneer herinneren",
          "options": {
            "-1": "Onmiddelijk na het vastleggen van de afspraak",
            "120": "2 uur voor de afspraak",
            "1440": "1 dag voor de afspraak",
            "2880": "2 dagen voor de afspraak",
            "30": "30 minuten voor de afspraak",
            "4320": "3 dagen voor de afspraak",
            "60": "1 uur voor de afspraak",
            "7200": "5 dagen voor de afspraak"
          },
          "scope_id": "Deze instellingen toepassen voor"
        },
        "consultation_type": {
          "duration": "Duur",
          "icon": "Icoon",
          "name": "Naam"
        },
        "contact": {
          "address": {
            "country": "Land",
            "line1": "Adres"
          },
          "age_descriptor": "(%{age} jaar)",
          "birthday": "Geboortedatum",
          "email": "Email",
          "extra_remark": "Opmerking",
          "first_name": "Voornaam",
          "health_fund": "Mutualiteit",
          "last_name": "Familienaam",
          "phone": "Telefoonnummer",
          "security_number": "Rijksregisternummer",
          "title": "Contact"
        },
        "document": {
          "attachment": "Bestand"
        },
        "dossier": {
          "communication_receiver": "Communicatie versturen naar",
          "dossier_number": "Dossiernummer",
          "extra_remark": "Extra opmerking bij persoonsgegevens",
          "health_fund_id": "Mutualiteit",
          "invoice_receiver": "Factureren aan",
          "location_id": "Praktijk",
          "responsible_ids": "Verantwoordelijke zorgverlener",
          "title": "Dossier"
        },
        "dossier_item": {
          "attachment": "Bijlage",
          "time": "Datum"
        },
        "email_communication": {
          "body": "Tekst",
          "subject": "Onderwerp",
          "title": "Email Opstellen"
        },
        "email_template": {
          "body": "Tekst",
          "email_type": "Type",
          "location_id": "Praktijk",
          "subject": "Onderwerp",
          "title": "Email"
        },
        "employment": {
          "communication_email": "Mail-adres waarmee je communiceert met cliënten",
          "name": "Naam",
          "riziv_number": "RIZIV-nummer of Visumnummer",
          "signature": "Een foto van je handtekening om toe te voegen aan documenten",
          "signature_form": {
            "edit": "Handtekening bewerken",
            "new": "Handtekening toevoegen",
            "title": "Handtekening"
          }
        },
        "event": {
          "calendar": "Agenda",
          "consultation": "Linken aan",
          "duration": "Duur",
          "end_time": "Eindigt op",
          "start_time": "Tijdstip",
          "summary": "Titel",
          "title": "Planning"
        },
        "generate_consultation_error": {
          "match_id": "Koppelen aan"
        },
        "health_fund": {
          "email": "Email",
          "naam": "Naam",
          "name": "Naam",
          "phone": "Telefoonnummer"
        },
        "invoice": {
          "already_invoiced": "Een reeds uitgegeven factuur kan je niet meer bewerken",
          "anonymized": "Naam van de cliënt verbergen op factuur",
          "concept": "Concept",
          "consultations": "Consultaties in deze factuur",
          "credit_note_reason": "Reden voor de creditering",
          "dossier_id": "Cliënt",
          "identification": "Volgnummer",
          "invoice_date": "Factuurdatum",
          "new": {
            "credit_note": "Creditnota maken",
            "credit_note_header": "Creditnota voor factuur %{invoice_number}",
            "from_dossier": "Genereren voor %{dossier}",
            "from_dossier_placeholder": "Genereren op basis van consultaties",
            "from_empty": "Starten vanaf lege factuur"
          },
          "paid": "Voldaan",
          "payed_at": "Betaald",
          "proposed": "Voorgesteld",
          "receiver_id": "Ontvanger",
          "send_as_mail": "Versturen?",
          "sender_config_id": "Afzender"
        },
        "invoice_configuration": {
          "enterprise_number": "Ondernemingsnummer",
          "errors": {
            "invalid_key": "Peppyrus API Key is ongeldig",
            "not_on_peppol": "De registratie van jou deelnemer-ID op Peppyrus is nog niet voltooid."
          },
          "iban": "Bankrekeningnummer",
          "invoice_conditions": "Betalingsvoorwaarden",
          "invoice_message": "Mededeling op een factuur",
          "name": "Naam onderneming",
          "peppyrus_api_key": "Peppyrus API Key",
          "peppyrus_api_key_explainer": "ZorgMee heeft een integratie met Peppyrus om rechtstreeks je facturen op het peppol-netwerk te kunnen sturen.",
          "peppyrus_api_key_explainer_link": "Download de instructies",
          "peppyrus_api_key_explainer_part2": "om de integratie te activeren.",
          "scope_id": "Deze instellingen toepassen voor",
          "start_invoice_identification": "Eerstvolgende factuurnummer",
          "title": "Factuurinstellingen",
          "vat_free": "Ik ben vrijgesteld van BTW",
          "what_is_peppyrus_api_key": "Wat is dit?"
        },
        "invoice_item": {
          "description": "Omschrijving",
          "price": "Prijs",
          "quantity": "Aantal",
          "title": "Factuurlijnen",
          "unit": "Eenheid",
          "vat_percentage": "BTW"
        },
        "location": {
          "email": "Contact emailadres",
          "logo": "Logo",
          "name": "Naam",
          "phone": "Telefoonnummer",
          "primary_color": "Themakleur",
          "responsible_id": "Verantwoordelijke zorgverlener",
          "website": "Website"
        },
        "not_in_scope": "Omdat deze instelling van toepassing is op meerdere medewerkers, kan ze alleen worden gewijzigd door de praktijkverantwoordelijke.",
        "office": {
          "email": "Email",
          "logo": "Logo",
          "name": "Praktijknaam"
        },
        "organisation": {
          "email": "Email",
          "enterprise_number": "Ondernemingsnummer",
          "name": "Naam",
          "organisation_type": "Ondernemingsvorm",
          "organisation_types": {
            "bv": "BV",
            "commnv": "Comm. V",
            "commva": "Comm. VA",
            "cvba": "CVBA",
            "cvoa": "CVOA",
            "eenmanszaak": "Eenmanszaak",
            "nv": "NV",
            "vof": "VOF",
            "vzw": "VZW"
          },
          "phone_number": "Telefoonnummer"
        },
        "receipt": {
          "identification": "Nummer",
          "title": "Ontvangstbewijs"
        },
        "relationship": {
          "contact_id": "Contact",
          "options": {
            "gp": "Huisarts",
            "invoice_receiver": "Factureren aan",
            "organisation": "Organisatie",
            "other": "Andere",
            "othercarer": "Andere hulpverlener",
            "partner": "Partner",
            "pediatrician": "Kinderarts",
            "psychiatrist": "Psychiater",
            "referrer": "Doorverwijzer",
            "school": "School",
            "standardparent": "Ouder",
            "stepparent": "Plusouder"
          },
          "organisation_id": "Organisatie",
          "relationship_type": "Relatie",
          "title": "Contactpersonen"
        },
        "template": {
          "body": "Inhoud",
          "scope_id": "Deze template kan gebruikt worden door",
          "subject": "Onderwerp"
        }
      },
      "search": {
        "contacts": {
          "of": "van"
        },
        "types": {
          "addresses": "Adres",
          "calendar": "Kalenders",
          "consultations": "Consultaties",
          "contacts": "Contacten",
          "dossiers": "Clienten",
          "email_templates": "Emailtemplate",
          "locations": "Werklocaties",
          "office": "Praktijk",
          "organisations": "Organisaties",
          "receipts": "Ontvangstbewijzen"
        }
      }
    },
    "billing": {
      "line_items": {
        "annual": "EPD ZorgMee - per jaar",
        "monthly": "EPD ZorgMee - per maand",
        "per_consult": "EPD ZorgMee - per consult"
      }
    },
    "channels": {
      "calendar_sync": {
        "statuses": {
          "ok": "Synchronisatie beëindigd",
          "sync_running": "Synchroniseren van ",
          "sync_started": "Synchroniseren van ",
          "syncing": "Synchroniseren van "
        }
      },
      "generate_consultations": {
        "statuses": {
          "generate_running": "Aanmaken/controleren consultaties gestart",
          "generate_started": "Aanmaken/controleren consultaties voorbereiden",
          "generating": "Aanmaken/controleren consultaties",
          "ok": "Aanmaken/controleren consultaties beëindigd"
        }
      },
      "tag_events_run": {
        "statuses": {
          "ok": "Verwerken agendapunten beëindigd",
          "tagging": "Verwerken agendapunten",
          "tagging_running": "De agenda wordt ingeladen",
          "tagging_started": "Inladen agenda is gestart"
        }
      }
    },
    "components": {
      "add_new_menu_item": {
        "dropdown_items": {
          "contact": "Nieuw contact",
          "dossier": "Nieuwe cliënt",
          "invoice": "Nieuwe factuur",
          "organisation": "Nieuwe organisatie"
        }
      },
      "address_form": {
        "bus": "Bus",
        "city": "Stad",
        "country": "Land",
        "house_number": "Huisnummer",
        "postal_code": "Postcode",
        "street": "Straat",
        "submit": "Opslaan",
        "title": "Adres"
      },
      "big_calendar": {
        "agenda": "Agenda",
        "allDay": "De hele dag",
        "date": "Datum",
        "day": "Dag",
        "event": "Afspraak",
        "month": "Maand",
        "next": "Volgende",
        "previous": "Vorige",
        "time": "Tijd",
        "today": "Vandaag",
        "tomorrow": "Morgen",
        "week": "Week",
        "work_week": "Werkweek",
        "yesterday": "Gisteren"
      },
      "calendar_form": {
        "calendar_type": {
          "consultations": "Consultaties",
          "other": "Andere"
        }
      },
      "calendar_list": {
        "calendar_type": {
          "consultations": "Consultaties",
          "other": "Andere"
        },
        "destroy": "Verwijderen",
        "destroy_warning": "Pas op! Deze agenda heeft agendapunten en bijhorende consultaties",
        "title": "Agendas"
      },
      "calendars_list": {
        "disabled_for_admin": "Een nieuwe agenda kan enkel toegevoegd worden door de zorgverlener zelf, en dus niet vanaf het praktijkoverzicht",
        "new": "Nog een agenda toevoegen",
        "title": "Agendas"
      },
      "communication_recipients": {
        "default_target": "de patiënt zelf",
        "lead": "Communicatie wordt gestuurd naar",
        "no_email": "Dit contact heeft geen e-mailadres en zal dus niets ontvangen.",
        "role": "de %{role}:",
        "to_target": "%{names}"
      },
      "compass": {
        "consultations": "Consultaties vandaag",
        "dossiers": "Actuele cliënten",
        "invoices": "Recente facturen",
        "stats": "Cijfers",
        "todos": "Todo's"
      },
      "configuration": {
        "calendars": "Agendas",
        "consultation_prices": "Consultaties",
        "email_templates": "Emails",
        "employments": "Medewerkers",
        "invoice_configuration": "Facturen",
        "locations": "Werklocaties",
        "office": "Zorgverlener",
        "templates": "Templates"
      },
      "consultation_reminders_list": {
        "destroy": "Verwijderen",
        "destroy_warning": "Cliënten zullen deze herinnering niet meer ontvangen",
        "new": "Nieuwe afspraakherinnering",
        "title": "Afspraakherinneringen"
      },
      "consultation_type_list_item": {
        "destroy": "Verwijderen",
        "destroy_warning": "Bestaande afspraken van dit type zullen ingesteld worden als standaard Consultatie.",
        "protected": "Standaardtype niet bewerkbaar",
        "since": "Aangemaakt op %{date}"
      },
      "consultation_types_list": {
        "new": "Nieuw ConsultatieType",
        "title": "Consultatie types"
      },
      "consultation_types_selector": {
        "edit": "ConsultatieType Bewerken"
      },
      "consultations_list": {
        "new": "Nieuwe consultatie",
        "none": "Er zijn geen consultaties gepland in deze periode.",
        "submit": "Opslaan",
        "title": "Consultaties",
        "unknown_consultation_type": "Onbekend consultatie type"
      },
      "contact": {
        "is_archived": "De cliënt horende bij dit contact is gearchiveerd",
        "title": "Contact"
      },
      "contacts_list": {
        "new": "Nieuw contact",
        "none": "Er zijn momenteel nog geen contacten ingesteld",
        "title": "Contacten"
      },
      "contacts_list_item": {
        "since": "Aangemaakt op %{date}"
      },
      "contacts_selector": {
        "edit": "Contact bewerken",
        "new": "Nieuw contact"
      },
      "destroy_modal": {
        "cancel": "Annuleren",
        "confirmation": "Bevestig door hier 'DELETE' te typen",
        "destroy": "Verwijderen",
        "title": "Ben je zeker dat je dit wenst te verwijderen?"
      },
      "documents_list": {
        "new": "Document uploaden",
        "title": "Documenten"
      },
      "dossier": {
        "archive": "Cliënt archiveren",
        "basic_info": "Persoonsgegevens",
        "documents": {
          "bilan": {
            "aid_request": "Hulpvraag",
            "conclusion": "Afronding",
            "plan": "Voorgestelde hulp",
            "symptoms": "Klachten",
            "title": "Functioneel Bilan aanmaken"
          },
          "create_bilan": "Functioneel Bilan",
          "create_from_template_button": "Starten vanaf template",
          "create_health_fund_certificate": "Attest Mutualiteit",
          "generate": "Genereren",
          "health_fund_certificate_from": "Consultaties meerekenen vanaf",
          "template_form": {
            "template_field": "Template",
            "title": "Document aanmaken vanaf template"
          },
          "title": "Andere documenten downloaden",
          "upload": "Uploaden"
        },
        "export": {
          "explanation": "Kies wat je wil meenemen in de export.",
          "export_button": "Exporteren",
          "export_pdf": "Dossier exporteren",
          "with_attachments": "Inclusief bijlagen bij de notities",
          "with_notes": "Inclusief notities"
        },
        "financial": "Documenten",
        "follow_up": "Dossier",
        "is_archived": "Deze cliënt is gearchiveerd",
        "merge": {
          "explanation_p1": "Met deze actie kun je twee dossiers samenvoegen.",
          "explanation_p2": "De consultaties, notities, documenten, facturen,.. van het tweede dossier worden overzet naar het hoofddossier.",
          "explanation_p3": "Opgepast: de persoonsgegevens van het tweede dossier worden gewist. Van het hoofddossier wordt alles behouden.",
          "main_dossier": "Hoofddossier",
          "merge": "Samenvoegen",
          "other_dossier": "Tweede dossier",
          "title": "Twee dossiers samenvoegen"
        },
        "no_consultations": "Er zijn (nog) geen consultaties voor deze cliënt",
        "not_loaded": "We halen het dossier voor je op.",
        "restore": "Cliënt terugzetten uit archief"
      },
      "dossier_basic_info": {
        "address": "Adres",
        "header": "Algemene info"
      },
      "dossier_documents": {
        "health_fund_error": "Er is nog geen mutualiteit aangeduid voor dit dossier"
      },
      "dossier_form": {
        "email": "Email",
        "first_name": "Voornaam",
        "gender": {
          "man": "Man",
          "other": "Andere",
          "woman": "Vrouw"
        },
        "header": "Algemene info",
        "invoice_receiver": {
          "contact": "Contact",
          "organisation": "Organisatie",
          "patient": "Client"
        },
        "last_name": "Achternaam",
        "new": "Nieuw",
        "patient": "Cliënt",
        "phone_number": "Telefoonnummer",
        "submit": "Opslaan",
        "title": "Aanspreking"
      },
      "dossier_item": {
        "add": "Notitie",
        "age_descriptor": "%{age} jaar",
        "attachment": "Bijlage",
        "deleted_consult": "Notitie (consult verwijderd)",
        "destroy": {
          "attachment": "Bijlage verwijderen",
          "note": "Notitie verwijderen"
        },
        "new_attachment": "Nieuwe Bijlage",
        "not_loaded": "We halen dit dossierdeel voor je op.",
        "note": "Notitie",
        "toggle_visibility": {
          "image": {
            "hide": "Afbeeldingen verbergen",
            "show": "Afbeeldingen tonen"
          },
          "pdf": {
            "hide": "Inhoud van pdfs verbergen",
            "show": "Inhoud van pdfs tonen"
          }
        }
      },
      "dossier_items_list": {
        "new": "Nieuwe notitie",
        "none": "Er zijn momenteel nog geen notities",
        "title": "Notities"
      },
      "dossier_items_selector": {
        "edit": "Notitie bewerken"
      },
      "dossier_list_item": {
        "dossier_number": "Dossier:",
        "security_number": "RRN:",
        "since": "Geregistreerd op %{date}"
      },
      "dossiers": {
        "new": "Nieuw"
      },
      "dossiers_list": {
        "create": "Alles aanmaken",
        "new": "Nieuw",
        "none": "Geen cliënten gevonden",
        "save": "Alles opslaan",
        "search": "Zoeken ...",
        "title": "Cliënten"
      },
      "editor_node_drop": {
        "help_text_insert_after": "Sleep hier om toe te voegen.",
        "help_text_insert_child": "Sleep hier om er tussen in te voegen"
      },
      "email_communications_list": {
        "new": "Email - Opstellen"
      },
      "email_template_batch_form": {
        "email_type": {
          "invoice": "Factuur: voldaan",
          "invoice_first_reminder": "Factuur: eerste herinnering",
          "invoice_second_reminder": "Factuur: tweede herinnering",
          "invoice_unpaid": "Factuur: niet voldaan"
        }
      },
      "employments_list": {
        "title": "Medewerkers"
      },
      "employments_list_item": {
        "employment_type": {
          "administrative": "Administratie",
          "practice_manager": "Praktijkverantwoordelijke",
          "practitioner": "Zorgverlener",
          "support": "Support"
        },
        "since": "Aangemeld op %{date}"
      },
      "entities_list": {
        "add": "Nieuw",
        "cancel": "Annuleren",
        "continue": "en verder aanpassen",
        "loading": "Laden ...",
        "none": "Deze lijst is nog leeg.",
        "overview": "en naar overzicht",
        "search": "Zoeken",
        "submit": "Opslaan"
      },
      "entities_menu": {
        "not_found": "Geen resultaten"
      },
      "event": {
        "linked_dossier": "Cliënt: "
      },
      "events_selector": {
        "edit": "Afspraak bewerken"
      },
      "filters": {
        "consultation_type": "Consultatie Type",
        "employment": "Zorgverlener",
        "location": "Locatie",
        "name": "Naam",
        "paid": "Betalingsstatus",
        "paid_options": {
          "false": "Onbetaald",
          "true": "Betaald"
        },
        "proposed": "Opmaakstatus",
        "proposed_options": {
          "false": "Reeds opgemaakt",
          "true": "Voorgesteld"
        }
      },
      "generate_consultation_errors_list_item": {
        "error_descriptions": {
          "consultation_type": {
            "multiple_matches": "Er werden meerdere consultatietypes gevonden die gekoppeld kunnen worden aan deze afspraak.",
            "weak_match": "Vermoedelijk werd het consultatietype '%{match}' fout geschreven. Gelieve daarom nog even te bevestigen dat het wel degelijk om het juiste type gaat."
          },
          "dossier": {
            "multiple_matches": "Er werden meerdere cliënten gevonden die gekoppeld kunnen worden aan deze afspraak.",
            "no_match": "Er werd geen cliënt gevonden die gekoppeld kan worden aan deze afspraak.",
            "weak_match": "Vermoedelijk werd de cliënt '%{match}' fout geschreven. Gelieve daarom nog even te bevestigen dat het wel degelijk om de juiste cliënt gaat."
          }
        },
        "ignore": "Negeer Afspraak",
        "match_to": "Koppelen aan: ",
        "match_types": {
          "consultation_type": {
            "one": "consultatietype",
            "other": "consultatietypes"
          },
          "dossier": {
            "one": "cliënt",
            "other": "cliënten"
          }
        },
        "new_dossier": "Nieuwe cliënt",
        "other": "Andere",
        "select_patient": "Selecteer cliënt"
      },
      "geocoder_widget": {
        "search": "Zoek hier een adres ..."
      },
      "health_funds_list": {
        "title": "Mutualiteiten"
      },
      "invoice": {
        "confirm_mail": "Opnieuw sturen",
        "confirm_mail_info": "Pas op, reeds verstuurd!",
        "consultations": "Consultaties op deze factuur",
        "credit_note_for": "Creditnota voor Factuur %{invoice_number}",
        "no_consultations": "Er zijn geen consultaties op deze factuur",
        "title": "Factuur",
        "title_credit_note": "Creditnota",
        "title_proposed": "Voorgestelde factuur"
      },
      "invoice_configurations_list": {
        "new": "Nieuwe Factuurinstellingen",
        "title": "Factuurinstellingen"
      },
      "invoice_form": {
        "unit": {
          "hours": "u",
          "km": "km",
          "piece": "stuks",
          "session": "sessies"
        }
      },
      "invoices_list": {
        "new": "Factuur opstellen",
        "none": "Geen facturen gevonden",
        "title": "Facturen"
      },
      "invoices_list_item": {
        "concept": "Concept",
        "invoice_date": "Factuurdatum: %{date}",
        "paid": "Voldaan",
        "proposed": "Voorgesteld",
        "sent": "Verzonden",
        "sent_at": "Verzonden op %{date}",
        "since": "Aangemaakt op %{date}"
      },
      "locations_list": {
        "new": "Nieuwe locatie",
        "none": "Er zijn momenteel nog geen locaties ingesteld, druk op nieuwe locatie",
        "read_only": "Deze instellingen kunnen alleen worden gewijzigd door de praktijkverantwoordelijke, je kunt ze wel bekijken.",
        "submit": "Opslaan",
        "title": "Locaties"
      },
      "login": {
        "google_compliance_disclosure": "Google API gebruik",
        "header": "Welkom bij EPD ZorgMee",
        "login_with_google": "Inloggen met Google",
        "login_with_microsoft": "Inloggen met Microsoft",
        "privacy_policy": "Privacyverklaring",
        "terms_of_use": "Gebruiksvoorwaarden"
      },
      "main_app": {
        "continue": "Ga verder",
        "error_header": "Oeps! Er is iets misgegaan.",
        "error_subheader": "Maak u geen zorgen, we werden reeds op de hoogte gebracht van deze fout.",
        "main_menu": {
          "admin": "Praktijkoverzicht"
        },
        "menu": {
          "consultations": "Agenda",
          "dossiers": "Cliënten",
          "management": "Administratie",
          "today": "Dashboard"
        },
        "welcome": "Er werd nog geen omgeving voor uw account ingesteld."
      },
      "main_modal": {
        "contact": {
          "email": "info@zorgmee.be",
          "text": "Is dit niet wat je verwacht of blijft dit gebeuren? Laat het ons weten via"
        },
        "error_modal": {
          "close": "Doorgaan",
          "text": "Ohnee, er is een fout opgetreden. Wij werden hier automatisch op de hoogte van gebracht.",
          "title": "Er ging iets mis"
        },
        "forbidden_modal": {
          "back_to_home": "Terug naar home",
          "text": "Je hebt niet de juiste toegangsrechten om iets op deze pagina te bekijken of bewerken. ",
          "title": "Geen toegang"
        },
        "not_found_modal": {
          "back_to_home": "Terug naar home",
          "text": "We kunnen de pagina die je zoekt niet vinden, mogelijks bestaat deze niet meer, of mischien zit er een typfout in de url",
          "title": "Oeps, verkeerde afslag!"
        },
        "session_modal": {
          "login": "Inloggen",
          "text": "Er is een tijdje geen activiteit meer geweest in de applicatie. Om te voorkomen dat iemand anders jou cliëntgegevens zou kunnen inkijken terwijl U weg bent, hebben we je alvast even uitgelogd. Om verder te werken kan je opnieuw inloggen",
          "title": "Sessie verlopen"
        }
      },
      "management_menu": {
        "menu": {
          "contacts": "Contacten",
          "invoices": "Facturen",
          "organisations": "Organisaties",
          "receipts_journal": "Ontvangstendagboek"
        }
      },
      "match_proposal_list_item": {
        "descriptions": {
          "multiple_both": "Er werden meerdere cliënten en consultatietypes gevonden die gekoppeld kunnen worden aan deze afspraak.",
          "multiple_consultation_types": "Er werden meerdere consultatietypes gevonden die gekoppeld kunnen worden aan deze afspraak.",
          "multiple_dossiers": "Er werden meerdere cliënten gevonden die gekoppeld kunnen worden aan deze afspraak.",
          "no_match": "Er werd geen cliënt gevonden die gekoppeld kan worden aan deze afspraak."
        },
        "not_a_consultation": "Dit is geen consult",
        "other": "Andere",
        "select_patient": "Selecteer cliënt",
        "select_type": "Selecteer type"
      },
      "not_found": {
        "back_home": "Terug naar home",
        "header": "Oeps, verkeerde afslag!",
        "subheader": "We kunnen de pagina die je zoekt niet vinden, mogelijks bestaat deze niet meer, of mischien zit er een typfout in de url"
      },
      "note": {
        "title": "Notitie"
      },
      "notifications": {
        "title": "Meldingen"
      },
      "notifications_list": {
        "none": "Er zijn geen meldingen"
      },
      "notifications_list_item": {
        "ignore": "Afspraak negeren",
        "messages": {
          "consultation_reminder_no_user": "De afspraakherinnering voor de afspraak met '%{name}' op %{date}\n\nkon niet verstuurd worden, omdat dit contact nog geen email-adres heeft\n"
        },
        "resolve": "Bevestigen",
        "titles": {
          "consultation_reminder_no_user": "Afspraakherinnering niet verstuurd",
          "generate_consultation_error": {
            "consultation_type": {
              "multiple_matches": "Meerdere consultatietypes mogelijk:",
              "no_match": "Linken niet mogelijk:",
              "weak_match": "Consultatie type met foute schrijfwijze?"
            },
            "dossier": {
              "multiple_matches": "Meerdere opties mogelijk:",
              "no_match": "Linken niet mogelijk:",
              "weak_match": "Cliënt met foute schrijfwijze?"
            }
          },
          "match_proposal": {
            "multiple_both": "Meerdere cliënten en consultatietypes mogelijk:",
            "multiple_consultation_types": "Meerdere consultatietypes mogelijk:",
            "multiple_dossiers": "Meerdere cliënten mogelijk:",
            "no_match": "Linken niet mogelijk:"
          },
          "remove_consultation_error": {
            "has_document_items": "Er werd een afspraak verwijderd uit uw agenda, maar de consultatie die hierbij hoort heeft nog nota's",
            "has_invoice": "Een afspraak die u verwijderd hebt uit uw agenda heeft nog een consultatie met factuur",
            "has_multiple": "Een afspraak die u verwijderd hebt uit uw agenda heeft nog een consultatie.",
            "has_receipt": "Een afspraak die u verwijderd hebt uit uw agenda heeft nog een ontvangsbewijs."
          }
        }
      },
      "office_selector": {
        "unselected": "Omgeving"
      },
      "offices_list": {
        "title": "Zorgverleners"
      },
      "organisation": {
        "title": "Organisatie"
      },
      "organisations_list": {
        "new": "Nieuwe organisatie",
        "none": "Er zijn momenteel nog geen organisaties ingesteld",
        "title": "Organisaties"
      },
      "organisations_selector": {
        "new": "Nieuwe organisatie"
      },
      "patient_birthday_badge": {
        "day_after_consultation": "%{name} is jarig de dag na deze consultatie.",
        "day_before_consultation": "%{name} is jarig de dag voor deze consultatie.",
        "on_consultation": "%{name} is jarig de dag van deze consultatie.",
        "today": "%{name} is vandaag jarig.",
        "tomorrow": "%{name} is morgen jarig.",
        "yesterday": "%{name} was gisteren jarig."
      },
      "pdf_item": {
        "error": {
          "no_address_on_invoice_receiver": "De ontvanger voor deze factuur heeft geen adres",
          "no_address_on_patient": "De client heeft geen adres",
          "no_location": "Er is nog geen locatie aangeduid voor dit dossier",
          "no_location_responsible": "De ingestelde locatie heeft nog geen verantwoordelijke",
          "no_patient": "De patient op dit dossier is nog niet ingesteld",
          "no_responsible": "Er werd nog geen verantwoordelijke aangeduid voor dit dossier",
          "no_user_on_invoice_receiver": "De ontvanger voor deze factuur heeft geen emailadres",
          "no_user_on_patient": "De client heeft geen emailadres",
          "proposed": "De factuur is slechts voorgesteld, ze is nog niet bevestigd"
        }
      },
      "peppol_item": {
        "error": {
          "customer_not_registered": "Deze klant is niet geregistreerd bij Peppol",
          "no_country_code": "Er is geen adres ingesteld voor deze organisatie",
          "no_enterprise_number": "Er is geen btw-nummer ingesteld voor deze organisatie",
          "not_an_organisation": "De ontvanger van deze factuur is geen organisatie",
          "not_configured": "Peppol-verbinding nog niet ingesteld, zie: 'Instellingen > Facturen'",
          "sending": "Aan het sturen",
          "sending_timeout": "Verzenden mislukt",
          "sent": "Reeds verstuurd",
          "unexpected_failure": "Verzenden mislukt",
          "validation_failed": "Verzenden mislukt"
        },
        "send": "Versturen op het Peppol netwerk"
      },
      "placeholder": {
        "content": "Start hier met het maken van je tekst"
      },
      "receipts_journal": {
        "title": "Ontvangstendagboek"
      },
      "remove_consultation_errors_list_item": {
        "error_descriptions": {
          "has_document_items": "Er werd een afspraak verwijderd uit uw agenda, maar de consultatie die hierbij hoort heeft nog nota's",
          "has_invoice": "Er werd een afspraak verwijderd uit uw agenda, maar de consultatie die hierbij hoort heeft een factuur",
          "has_multiple": "Er werd een afspraak verwijderd uit uw agenda, maar de consultatie die hierbij hoort kan nog niet verwijderd worden",
          "has_receipt": "Er werd een afspraak verwijderd uit uw agenda, maar de consultatie die hierbij hoort heeft een ontvangsbewijs"
        },
        "ignore": "Consultatie behouden",
        "remove": "Consultatie verwijderen",
        "restore": "Afspraak terugzetten"
      },
      "rich_text": {
        "add_mention": "Gegevens gebruiken",
        "add_template": "Template invoegen",
        "consultation_date": "Datum Afspraak",
        "consultation_dates": "Data van afgelopen consultaties",
        "consultation_dates_and_hours": "Data met uur van afgelopen consultaties",
        "consultation_hour": "Uur Afspraak",
        "example": "Voorbeeld",
        "first_consult_date": "Datum eerste consult",
        "latest_consult_date": "Datum recentste consult",
        "location_address": "Naam en Adres van de locatie",
        "location_name": "Naam van de locatie",
        "patient_first_name": "Voornaam Cliënt",
        "patient_last_name": "Familienaam Cliënt",
        "signature": "Handtekening"
      },
      "schema_form": {
        "cancel": "Annuleren",
        "submit": "Opslaan"
      },
      "search_menu_item": {
        "no_results": "We konden geen resultaten vinden",
        "placeholder": "Zoek...",
        "search_archives": "Klik hier om ook in het archief te zoeken"
      },
      "semantic_file_widget": {
        "dict_cancel_upload": "Upload annuleren",
        "dict_cancel_upload_confirmation": "Bent u zeker dat u deze upload wenst te annuleren?",
        "dict_default_message": "Sleep je bestand naar deze zone, of klik hier.",
        "dict_fallback_message": "Oei, je browser ondersteund het slepen van bestanden niet. Het is tijd om je browser up te daten.",
        "dict_fallback_text": "Gelieve het onderstaande formulier te gebruiken in de plaats",
        "dict_file_too_big": "Dit bestand is helaas te groot. Maximale bestandsgrote: 5 MB.",
        "dict_invalid_file_type": "U kan dit type bestanden niet uploaden",
        "dict_max_files_exceeded": "U kan geen extra bestanden meer opladen",
        "dict_remove_file": "Bestand verwijderen",
        "dict_response_error": "Oeps, er ging iets fout. We trachten dit zo snel mogelijk voor je op te lossen",
        "new_record": "Eens je werklocatie is aangemaakt kan je hier je logo toevoegen"
      },
      "semantic_select_field": {
        "blank": "(Geen)",
        "blank_alternate": "(Alles)"
      },
      "semantic_slice_field": {
        "history": "Historiek"
      },
      "send_email_item": {
        "submit": "Versturen"
      },
      "setup_wizard": {
        "calendar_settings": "Ten slotte zetten we de koppeling met je agenda op",
        "done": "Klaar",
        "location_settings": "Super, nu nog de info over jou werklocatie. Als je op meerdere locaties werkt kun je later nog een extra locatie toevoegen in de instellingen",
        "next": "Volgende",
        "office_settings": "We beginnen met de info over jezelf als zorgverlener:",
        "start": "Aan de slag",
        "title": "Enkele instellingen om te beginnen..",
        "welcome": "Welkom bij EPD ZorgMee! Om je op weg te helpen, beginnen we alvast met enkele instellingen samen in te vullen. (Geen nood, deze kun je later nog aanpassen)"
      },
      "stats": {
        "consultations_next_week": "Consultaties volgende week",
        "consultations_this_week": "Consultaties deze week",
        "consultations_today": "Consultaties vandaag",
        "consultations_tomorrow": "Consultaties morgen",
        "dossiers": "Cliënten"
      },
      "templates_list": {
        "new": "Nieuw",
        "title": {
          "letter": "Templates voor brieven",
          "note": "Templates voor notities"
        }
      },
      "templates_selector": {
        "edit": "Template bewerken"
      },
      "todo_list": {
        "client_search_placeholder": "Zoek cliënt…",
        "link_client": "Cliënt koppelen",
        "placeholder": "Nieuwe taak…"
      }
    },
    "countries": {
      "ac": "Ascension",
      "ad": "Andorra",
      "ae": "Verenigde Arabische Emiraten",
      "af": "Afghanistan",
      "ag": "Antigua en Barbuda",
      "ai": "Anguilla",
      "al": "Albanië",
      "am": "Armenië",
      "an": "Nederlandse Antillen",
      "ao": "Angola",
      "aq": "Antarctica",
      "ar": "Argentinië",
      "as": "Amerikaans-Samoa",
      "at": "Oostenrijk",
      "au": "Australië",
      "aw": "Aruba",
      "ax": "Åland",
      "az": "Azerbeidzjan",
      "ba": "Bosnië en Herzegovina",
      "bb": "Barbados",
      "bd": "Bangladesh",
      "be": "België",
      "bf": "Burkina Faso",
      "bg": "Bulgarije",
      "bh": "Bahrein",
      "bi": "Burundi",
      "bj": "Benin",
      "bl": "Saint-Barthélemy",
      "bm": "Bermuda",
      "bn": "Brunei",
      "bo": "Bolivia",
      "bq": "Caribisch Nederland",
      "br": "Brazilië",
      "bs": "Bahama’s",
      "bt": "Bhutan",
      "bv": "Bouveteiland",
      "bw": "Botswana",
      "by": "Wit-Rusland",
      "bz": "Belize",
      "ca": "Canada",
      "cc": "Cocoseilanden",
      "cd": "Congo-Kinshasa",
      "cf": "Centraal-Afrikaanse Republiek",
      "cg": "Congo-Brazzaville",
      "ch": "Zwitserland",
      "ci": "Ivoorkust",
      "ck": "Cookeilanden",
      "cl": "Chili",
      "cm": "Kameroen",
      "cn": "China",
      "co": "Colombia",
      "cp": "Clipperton",
      "cr": "Costa Rica",
      "cu": "Cuba",
      "cv": "Kaapverdië",
      "cw": "Curaçao",
      "cx": "Christmaseiland",
      "cy": "Cyprus",
      "cz": "Tsjechië",
      "de": "Duitsland",
      "dg": "Diego Garcia",
      "dj": "Djibouti",
      "dk": "Denemarken",
      "dm": "Dominica",
      "do": "Dominicaanse Republiek",
      "dz": "Algerije",
      "ea": "Ceuta en Melilla",
      "ec": "Ecuador",
      "ee": "Estland",
      "eg": "Egypte",
      "eh": "Westelijke Sahara",
      "er": "Eritrea",
      "es": "Spanje",
      "et": "Ethiopië",
      "eu": "Europese Unie",
      "fi": "Finland",
      "fj": "Fiji",
      "fk": "Falklandeilanden",
      "fm": "Micronesia",
      "fo": "Faeröer",
      "fr": "Frankrijk",
      "ga": "Gabon",
      "gb": "Verenigd Koninkrijk",
      "gd": "Grenada",
      "ge": "Georgië",
      "gf": "Frans-Guyana",
      "gg": "Guernsey",
      "gh": "Ghana",
      "gi": "Gibraltar",
      "gl": "Groenland",
      "gm": "Gambia",
      "gn": "Guinee",
      "gp": "Guadeloupe",
      "gq": "Equatoriaal-Guinea",
      "gr": "Griekenland",
      "gs": "Zuid-Georgia en Zuidelijke Sandwicheilanden",
      "gt": "Guatemala",
      "gu": "Guam",
      "gw": "Guinee-Bissau",
      "gy": "Guyana",
      "hk": "Hongkong SAR van China",
      "hm": "Heard en McDonaldeilanden",
      "hn": "Honduras",
      "hr": "Kroatië",
      "ht": "Haïti",
      "hu": "Hongarije",
      "ic": "Canarische Eilanden",
      "id": "Indonesië",
      "ie": "Ierland",
      "il": "Israël",
      "im": "Isle of Man",
      "in": "India",
      "io": "Britse Gebieden in de Indische Oceaan",
      "iq": "Irak",
      "ir": "Iran",
      "is": "IJsland",
      "it": "Italië",
      "je": "Jersey",
      "jm": "Jamaica",
      "jo": "Jordanië",
      "jp": "Japan",
      "ke": "Kenia",
      "kg": "Kirgizië",
      "kh": "Cambodja",
      "ki": "Kiribati",
      "km": "Comoren",
      "kn": "Saint Kitts en Nevis",
      "kp": "Noord-Korea",
      "kr": "Zuid-Korea",
      "kw": "Koeweit",
      "ky": "Caymaneilanden",
      "kz": "Kazachstan",
      "la": "Laos",
      "lb": "Libanon",
      "lc": "Saint Lucia",
      "li": "Liechtenstein",
      "lk": "Sri Lanka",
      "lr": "Liberia",
      "ls": "Lesotho",
      "lt": "Litouwen",
      "lu": "Luxemburg",
      "lv": "Letland",
      "ly": "Libië",
      "ma": "Marokko",
      "mc": "Monaco",
      "md": "Moldavië",
      "me": "Montenegro",
      "mf": "Saint-Martin",
      "mg": "Madagaskar",
      "mh": "Marshalleilanden",
      "mk": "Macedonië",
      "ml": "Mali",
      "mm": "Myanmar (Birma)",
      "mn": "Mongolië",
      "mo": "Macau SAR van China",
      "mp": "Noordelijke Marianen",
      "mq": "Martinique",
      "mr": "Mauritanië",
      "ms": "Montserrat",
      "mt": "Malta",
      "mu": "Mauritius",
      "mv": "Maldiven",
      "mw": "Malawi",
      "mx": "Mexico",
      "my": "Maleisië",
      "mz": "Mozambique",
      "na": "Namibië",
      "nc": "Nieuw-Caledonië",
      "ne": "Niger",
      "nf": "Norfolk",
      "ng": "Nigeria",
      "ni": "Nicaragua",
      "nl": "Nederland",
      "no": "Noorwegen",
      "np": "Nepal",
      "nr": "Nauru",
      "nu": "Niue",
      "nz": "Nieuw-Zeeland",
      "om": "Oman",
      "pa": "Panama",
      "pe": "Peru",
      "pf": "Frans-Polynesië",
      "pg": "Papoea-Nieuw-Guinea",
      "ph": "Filipijnen",
      "pk": "Pakistan",
      "pl": "Polen",
      "pm": "Saint-Pierre en Miquelon",
      "pn": "Pitcairneilanden",
      "pr": "Puerto Rico",
      "ps": "Palestijnse gebieden",
      "pt": "Portugal",
      "pw": "Palau",
      "py": "Paraguay",
      "qa": "Qatar",
      "qo": "overig Oceanië",
      "re": "Réunion",
      "ro": "Roemenië",
      "rs": "Servië",
      "ru": "Rusland",
      "rw": "Rwanda",
      "sa": "Saoedi-Arabië",
      "sb": "Salomonseilanden",
      "sc": "Seychellen",
      "sd": "Soedan",
      "se": "Zweden",
      "sg": "Singapore",
      "sh": "Sint-Helena",
      "si": "Slovenië",
      "sj": "Spitsbergen en Jan Mayen",
      "sk": "Slowakije",
      "sl": "Sierra Leone",
      "sm": "San Marino",
      "sn": "Senegal",
      "so": "Somalië",
      "sr": "Suriname",
      "ss": "Zuid-Soedan",
      "st": "Sao Tomé en Principe",
      "sv": "El Salvador",
      "sx": "Sint-Maarten",
      "sy": "Syrië",
      "sz": "Swaziland",
      "ta": "Tristan da Cunha",
      "tc": "Turks- en Caicoseilanden",
      "td": "Tsjaad",
      "tf": "Franse Gebieden in de zuidelijke Indische Oceaan",
      "tg": "Togo",
      "th": "Thailand",
      "tj": "Tadzjikistan",
      "tk": "Tokelau",
      "tl": "Oost-Timor",
      "tm": "Turkmenistan",
      "tn": "Tunesië",
      "to": "Tonga",
      "tr": "Turkije",
      "tt": "Trinidad en Tobago",
      "tv": "Tuvalu",
      "tw": "Taiwan",
      "tz": "Tanzania",
      "ua": "Oekraïne",
      "ug": "Oeganda",
      "um": "Kleine afgelegen eilanden van de Verenigde Staten",
      "us": "Verenigde Staten",
      "uy": "Uruguay",
      "uz": "Oezbekistan",
      "va": "Vaticaanstad",
      "vc": "Saint Vincent en de Grenadines",
      "ve": "Venezuela",
      "vg": "Britse Maagdeneilanden",
      "vi": "Amerikaanse Maagdeneilanden",
      "vn": "Vietnam",
      "vu": "Vanuatu",
      "wf": "Wallis en Futuna",
      "ws": "Samoa",
      "xk": "Kosovo",
      "ye": "Jemen",
      "yt": "Mayotte",
      "za": "Zuid-Afrika",
      "zm": "Zambia",
      "zw": "Zimbabwe",
      "zz": "onbekend gebied"
    },
    "data": {
      "default_consultation_types": [
        {
          "title": "Consultatie",
          "icon": "talk"
        },
        {
          "title": "Intake",
          "icon": "handshake"
        },
        {
          "title": "No-show",
          "icon": "user times",
          "cancellation": true
        },
        {
          "title": "Annulatie",
          "icon": "calendar times",
          "cancellation": true
        }
      ],
      "example_templates": [
        {
          "subject": "Attest van Begeleiding",
          "body": "<p>Beste,</p><p></p><p>Hierbij bevestigen wij dat @mention{patient_first_name} @mention{patient_last_name} op @mention{first_consult_date} gestart is met een psychologische</p><p>begeleiding in onze praktijk.</p><p></p><p>Reeds gevolgde consulten:</p><p>@mention{consultation_dates}</p><p></p><p>Met Vriendelijke Groet,</p>"
        },
        {
          "subject": "Afwezigheidsattest",
          "body": "<p>Beste,</p><p></p><p>Hierbij bevestigen wij dat @mention{patient_first_name} @mention{patient_last_name} de sessies heeft bijgewoond op onderstaande momenten:</p><p>@mention{consultation_dates_and_hours}</p><p></p><p>Met Vriendelijke Groet,</p>"
        },
        {
          "subject": "Toestemming informatie delen",
          "body": "<h2><strong>Toestemming delen van informatie aan derden</strong></h2><p></p><p>Hierbij geef ik mijn zorgverlener toestemming tot uitwisseling van informatie met:</p><p></p><p>..........................................</p><p>..........................................</p><p>..........................................</p><p></p><p>Dit gaat om informatie die relevant is in het kader van mijn zorgtraject. Ik behoud hierbij steeds het recht op inzage van de gedeelde informatie, alsook de mogelijkheid om deze toestemming weer in te trekken.</p><p></p><p>Voor Akkoord:</p><p><em>(handtekening)</em></p><p></p><p></p><p></p><p></p><p>@mention{patient_first_name} @mention{patient_last_name}</p>"
        }
      ]
    },
    "date": {
      "abbr_day_names": [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mrt",
        "apr",
        "mei",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "human_readable": "%-d %b %Y",
        "long": "%e %B %Y",
        "short": "%e %b",
        "short_human_readable": "%-d %b %y",
        "with_weekday": "%a %d/%m/%y"
      },
      "from_date": "Van",
      "month_names": [
        null,
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "now": "Nu",
      "order": [
        "day",
        "month",
        "year"
      ],
      "to_date": "Tot",
      "today": "Vandaag"
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ongeveer een uur",
          "other": "ongeveer %{count} uur"
        },
        "about_x_months": {
          "one": "ongeveer een maand",
          "other": "ongeveer %{count} maanden"
        },
        "about_x_years": {
          "one": "ongeveer een jaar",
          "other": "ongeveer %{count} jaar"
        },
        "almost_x_years": {
          "one": "bijna een jaar",
          "other": "bijna %{count} jaar"
        },
        "half_a_minute": "een halve minuut",
        "less_than_x_minutes": {
          "one": "minder dan een minuut",
          "other": "minder dan %{count} minuten"
        },
        "less_than_x_seconds": {
          "one": "minder dan een seconde",
          "other": "minder dan %{count} seconden"
        },
        "over_x_years": {
          "one": "meer dan een jaar",
          "other": "meer dan %{count} jaar"
        },
        "x_days": {
          "one": "%{count} dag",
          "other": "%{count} dagen"
        },
        "x_minutes": {
          "one": "%{count} minuut",
          "other": "%{count} minuten"
        },
        "x_months": {
          "one": "%{count} maand",
          "other": "%{count} maanden"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} seconden"
        },
        "x_years": {
          "one": "%{count} jaar",
          "other": "%{count} jaar"
        }
      },
      "prompts": {
        "day": "dag",
        "hour": "uur",
        "minute": "minuut",
        "month": "maand",
        "second": "seconde",
        "year": "jaar"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Je account is bevestigd.",
        "new": {
          "resend_confirmation_instructions": "Verstuur bevestiging-instructies opnieuw"
        },
        "send_instructions": "Je ontvangt via e-mail instructies hoe je je account kan bevestigen.",
        "send_paranoid_instructions": "Als we je e-mailadres terugvinden in onze database, zal je binnen enkele ogenblikken een e-mail ontvangen met instructies hoe je je account kan bevestigen."
      },
      "failure": {
        "already_authenticated": "Je bent reeds aangemeld.",
        "inactive": "Je account is nog niet geactiveerd.",
        "invalid": "Ongeldig %{authentication_keys} of wachtwoord.",
        "last_attempt": "Je hebt nog één poging voordat je account vergrendeld wordt.",
        "locked": "Je account is vergrendeld.",
        "not_found_in_database": "Ongeldig %{authentication_keys} of wachtwoord.",
        "timeout": "Je sessie is verlopen, meld je opnieuw aan om door te gaan.",
        "unauthenticated": "Je dient je aan te melden of in te schrijven om door te gaan.",
        "unconfirmed": "Je dient eerst je account te bevestigen."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bevestig mijn account",
          "greeting": "Welkom %{recipient}!",
          "instruction": "Je kunt je e-mailadres bevestigen via onderstaande link:",
          "subject": "Bevestiging"
        },
        "email_changed": {
          "greeting": "Beste %{recipient}!",
          "message": "Het e-mailadres van uw account is gewijzigd in %{email}.",
          "message_unconfirmed": "We nemen contact op om je te laten weten dat je emailadres is gewijzigd naar %{email}.",
          "subject": "E-mailadres veranderd"
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "We stellen je met deze e-mail ervan op de hoogte dat je wachtwoord is gewijzigd.",
          "subject": "Je wachtwoord is gewijzigd"
        },
        "reset_password_instructions": {
          "action": "Verander mijn wachtwoord",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Iemand heeft een link gevraagd om uw wachtwoord te wijzigen; dit kan via onderstaande link.",
          "instruction_2": "Als je dit niet zelf hebt gevraagd, negeer deze mail dan alsjeblieft.",
          "instruction_3": "Je wachtwoord zal niet wijzigen totdat je bovenstaande link hebt gevolgd en een nieuw wachtwoord hebt aangemaakt.",
          "subject": "Instructies om je wachtwoord opnieuw in te stellen"
        },
        "unlock_instructions": {
          "action": "Ontgrendel mijn account",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Je kunt je account ontgrendelen via onderstaande link:",
          "message": "Je account is vergrendeld door te veel mislukte pogingen om in te loggen.",
          "subject": "Ontgrendelinstructies"
        }
      },
      "omniauth_callbacks": {
        "failure": "We konden je niet aanmelden op je %{kind} omdat \"%{reason}\".",
        "success": "Je bent succesvol ingelogd op je %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Verander mijn wachtwoord",
          "change_your_password": "Wijzig je wachtwoord",
          "confirm_new_password": "Bevestig nieuw wachtwoord",
          "new_password": "Nieuw wachtwoord"
        },
        "new": {
          "forgot_your_password": "Wachtwoord vergeten?",
          "send_me_reset_password_instructions": "Stuur me wachtwoord reset instructies"
        },
        "no_token": "Deze pagina is alleen bereikbaar via een wachtwoord vergeten e-mail. Als je wel via een wachtwoord vergeten e-mail komt, zorg er dan voor dat je de volledige URL gebruikt.",
        "send_instructions": "Je ontvangt een e-mail met instructies hoe je je wachtwoord opnieuw kan instellen.",
        "send_paranoid_instructions": "Als we je e-mailadres terugvinden in onze database, zal je binnen enkele ogenblikken via e-mail een link ontvangen om je wachtwoord opnieuw in te stellen.",
        "updated": "Je wachtwoord is gewijzigd. Je bent nu aangemeld.",
        "updated_not_active": "Je wachtwoord is met succes gewijzigd."
      },
      "registrations": {
        "destroyed": "Je account is verwijderd, wellicht tot ziens!",
        "edit": {
          "are_you_sure": "Weet je het zeker?",
          "cancel_my_account": "Annuleer mijn account",
          "currently_waiting_confirmation_for_email": "Aan het wachten op de bevestiging voor: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "laat leeg als je het niet wilt wijzigen",
          "title": "Bewerk %{resource}",
          "unhappy": "Niet blij",
          "update": "Bijwerken",
          "we_need_your_current_password_to_confirm_your_changes": "we hebben je huidige wachtwoord nodig om je veranderingen te bevestigen"
        },
        "new": {
          "sign_up": "Maak account aan"
        },
        "signed_up": "Je bent ingeschreven.",
        "signed_up_but_inactive": "Je bent ingeschreven, maar we konden je niet inloggen omdat je account nog niet is geactiveerd.",
        "signed_up_but_locked": "Je bent ingeschreven, maar we konden je niet inloggen omdat je account is vergrendeld.",
        "signed_up_but_unconfirmed": "Een e-mail met een confirmatielink is naar je e-mailadres gestuurd. Open de link in je browser om je account te activeren.",
        "update_needs_confirmation": "Je account is bijgewerkt, maar we moeten je e-mailadres nog valideren. Een e-mail met een confirmatielink is naar je e-mailadres gestuurd. Open de link in je browser om je e-mailadres te confirmeren.",
        "updated": "Je accountgegevens zijn opgeslagen.",
        "updated_but_not_signed_in": "Je account is succesvol bijgewerkt, maar omdat je wachtwoord is aangepast moet je opnieuw inloggen."
      },
      "sessions": {
        "already_signed_out": "Je bent succesvol uitgelogd.",
        "new": {
          "sign_in": "Inloggen"
        },
        "signed_in": "Je bent succesvol ingelogd.",
        "signed_out": "Je bent succesvol uitgelogd."
      },
      "shared": {
        "links": {
          "back": "Terug",
          "didn_t_receive_confirmation_instructions": "Geen bevestigingsmail ontvangen?",
          "didn_t_receive_unlock_instructions": "Geen ontgrendel-instructies ontvangen?",
          "forgot_your_password": "Wachtwoord vergeten?",
          "sign_in": "Inloggen",
          "sign_in_with_provider": "Inloggen met %{provider}",
          "sign_up": "Maak account aan"
        },
        "minimum_password_length": {
          "one": "(minimaal %{count} karakter)",
          "other": "(minimaal %{count} karakters)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Verstuur ontgrendel-instructies opnieuw"
        },
        "send_instructions": "Je ontvangt via e-mail instructies hoe je je account kan ontgrendelen.",
        "send_paranoid_instructions": "Als we je e-mailadres terugvinden in onze database, zal je binnen enkele ogenblikken een e-mail ontvangen met instructies hoe je je account kan ontgrendelen.",
        "unlocked": "Je account is ontgrendeld. Je kan nu weer inloggen."
      }
    },
    "dry_validation": {
      "errors": {
        "array?": "Hier hebben we een reeks nodig",
        "attr?": "Oeps, er is hier iets te kort",
        "bool?": "Vul hier JA of NEE in",
        "date?": "Hier hebben we een datum van het formaat DD-MM-JJJJ nodig",
        "date_time?": "Hier hebben we een datum van het formaat DD-MM-JJJJ nodig",
        "decimal?": "Hier hebben we een (komma)getal nodig",
        "empty?": "Dit veld mag je leeg laten",
        "eql?": "Dit getal is best gelijk aan %{left}",
        "even?": "Hier verwachten we een even getal",
        "excluded_from?": {
          "arg": {
            "default": "Hier vul je best één van de volgende waarden in: %{list}",
            "range": "Hier vul je best één van de volgende waarden in: %{list_left} - %{list_right}"
          }
        },
        "excludes?": "De volgende waarde kunnen we hier niet gebruiken:  %{value}",
        "exclusion?": "De volgende waarden kunnen we hier niet gebruiken: %{list}",
        "false?": "Hier hoor de waarde ONWAAR",
        "filled?": "Vul je dit nog even in?",
        "float?": "Hier hebben we een (komma)getal nodig",
        "format?": "Kijk je dit nog even na?",
        "gt?": "Dit getal is best groter dan %{num}",
        "gteq?": "Dit getal is best groter dan of gelijk aan %{num}",
        "hash?": "Hier verwachten we een hash",
        "included_in?": {
          "arg": {
            "default": "Hier vul je best één van de volgende waarden in: %{list}",
            "range": "Hier vul je best één van de volgende waarden in: %{list_left} - %{list_right}"
          }
        },
        "includes?": "Dit veld hoort inclusief de volgende waarde ingevuld te zijn: %{value}",
        "inclusion?": "Hier vul je best één van de volgende waarden in: %{list}",
        "int?": "Hier hebben we een geheel getal nodig",
        "key?": "Oeps, er is hier iets te kort",
        "lt?": "Dit getal is best kleiner dan aan %{num}",
        "lteq?": "Dit getal is best kleiner dan of gelijk aan %{num}",
        "max_size?": "Gebruik hier iets van %{num} letters of minder",
        "min_size?": "Gebruik hier iets van %{num} letters of langer",
        "none?": "Oeps, hier kunnen we niets uit halen",
        "not_eql?": "Dit getal is best niet gelijk aan %{left}",
        "number?": "Hier hebben we een getal nodig",
        "odd?": "Hier verwachten we een oneven getal",
        "or": "of",
        "rules": {
          "attachment": {
            "empty": "Geen bijlage, is er succesvol een bestand toegevoegd?"
          },
          "contact_id": {
            "empty": "Woepsiedoe, dit is nog leeg"
          },
          "email": {
            "format?": "Een emailadres heeft een @ en een . nodig"
          },
          "enterprise_number": {
            "invalid": "Oeps, dit ondernemingsnummer lijkt niet te kloppen"
          },
          "iban": {
            "invalid": "Oeps, dit rekiningnummer lijkt niet te kloppen"
          },
          "invoice_items": {
            "empty": "Een factuur heeft ten minste één factuurlijn nodig",
            "no_address_on_location": "De praktijk waar deze cliënt is ingeschreven heeft nog geen adres.",
            "no_configs_set": "Er zijn nog geen factuurinstellingen ingevuld. Zie instellingen",
            "no_enterprise_number_on_config": "De afzender van deze factuur heeft geen ondernemingsnummer. Zie factuurinstellingen"
          },
          "organisation_id": {
            "empty": "Woepsiedoe, dit is nog leeg"
          },
          "phone": {
            "invalid": "Hier verwachten we een telefoonnummer van het formaat +32 000 00 00 00"
          },
          "receiver_id": {
            "no_address": "De ontvanger heeft nog geen adres. ",
            "no_enterprise_number": "De ontvanger heeft nog geen ondernemingsnummer. "
          },
          "relationship_type": {
            "error": "Hier is iets fout gegaan, gelieve support te contacteren als dit blijft aanhouden"
          },
          "responsible_ids": {
            "empty": "Een cliënt heeft minstens één verantwoordelijke zorgverlener nodig"
          },
          "riziv_number": {
            "invalid": "Oeps, dit riziv-nummer lijkt niet te kloppen"
          },
          "security_number": {
            "invalid": "Oeps, dit rijksregisternummer lijkt niet te kloppen"
          },
          "start_invoice_identification": {
            "invalid": "Factuurnummers dienen verplicht oplopend te zijn, gelieve een getal te kiezen dat groter is dan dat van je laatste factuur"
          }
        },
        "size?": {
          "arg": {
            "default": "De grootte hiervan is best %{size}",
            "range": "De grootte hiervan ligt best in het volgende bereik: %{size_left} - %{size_right}"
          },
          "value": {
            "string": {
              "arg": {
                "default": "De lengte hiervan is best %{size}",
                "range": "De lengte hiervan ligt best in het volgende bereik: %{size_left} - %{size_right}"
              }
            }
          }
        },
        "str?": "Hier hebben we een woord nodig",
        "time?": "Hier hebben we een tijdstip van het formaat UU:MM nodig",
        "true?": "Hier hoort de waarde WAAR",
        "type?": "Hier verwachten we data van het type %{type}"
      }
    },
    "email_template_renderer": {
      "not_paid": "niet voldaan",
      "paid": "voldaan"
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "moet worden geaccepteerd",
        "already_confirmed": "is reeds bevestigd",
        "blank": "moet opgegeven zijn",
        "confirmation": "komt niet overeen met %{attribute}",
        "confirmation_period_expired": "moet binnen %{period} worden bevestigd, plaats a.u.b. een nieuw verzoek",
        "empty": "moet opgegeven zijn",
        "equal_to": "moet gelijk zijn aan %{count}",
        "even": "moet even zijn",
        "exclusion": "is gereserveerd",
        "expired": "is verlopen, vraag een nieuwe aan",
        "greater_than": "moet groter zijn dan %{count}",
        "greater_than_or_equal_to": "moet groter dan of gelijk zijn aan %{count}",
        "inclusion": "is niet in de lijst opgenomen",
        "invalid": "is ongeldig",
        "less_than": "moet minder zijn dan %{count}",
        "less_than_or_equal_to": "moet minder dan of gelijk zijn aan %{count}",
        "model_invalid": "Validatie mislukt: %{errors}",
        "not_a_number": "is geen getal",
        "not_an_integer": "moet een geheel getal zijn",
        "not_found": "niet gevonden",
        "not_locked": "is niet gesloten",
        "not_saved": {
          "one": "Een fout verhinderde het opslaan van deze %{resource}:",
          "other": "%{count} fouten verhinderde het opslaan van deze %{resource}:"
        },
        "odd": "moet oneven zijn",
        "other_than": "moet anders zijn dan %{count}",
        "present": "moet leeg zijn",
        "required": "moet bestaan",
        "taken": "is al in gebruik",
        "too_long": {
          "one": "is te lang (maximaal %{count} teken)",
          "other": "is te lang (maximaal %{count} tekens)"
        },
        "too_short": {
          "one": "is te kort (minimaal %{count} teken)",
          "other": "is te kort (minimaal %{count} tekens)"
        },
        "wrong_length": {
          "one": "heeft onjuiste lengte (moet %{count} teken lang zijn)",
          "other": "heeft onjuiste lengte (moet %{count} tekens lang zijn)"
        }
      },
      "template": {
        "body": "Er zijn problemen met de volgende velden:",
        "header": {
          "one": "%{model} niet opgeslagen: %{count} fout gevonden",
          "other": "%{model} niet opgeslagen: %{count} fouten gevonden"
        }
      }
    },
    "generic": {
      "add": "Toevoegen",
      "boolean_no": "Nee",
      "boolean_yes": "Ja",
      "create": "Aanmaken",
      "download": "Download",
      "empty": "(geen)",
      "new": "Nieuw",
      "ok": "Ok",
      "or": "of",
      "unknown": "(onbekend)"
    },
    "helpers": {
      "select": {
        "prompt": "Maak een keuze"
      },
      "submit": {
        "create": "%{model} toevoegen",
        "submit": "%{model} opslaan",
        "update": "%{model} bijwerken"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "ice_cube": {
      "array": {
        "last_word_connector": " en ",
        "two_words_connector": " en ",
        "words_connector": ", "
      },
      "at_hours_of_the_day": {
        "one": "op het %{segments} uur",
        "other": "op de %{segments} uren van de dag"
      },
      "at_seconds_of_minute": {
        "one": "op de %{segments} seconde",
        "other": "op de %{segments} seconden"
      },
      "date": {
        "formats": {
          "default": "%-d %B %Y"
        }
      },
      "days_of_month": {
        "one": "%{segments} dag van de maand",
        "other": "%{segments} dagen van de maand"
      },
      "days_of_week": "%{segments} %{day}",
      "days_of_year": {
        "one": "%{segments} dag van het jaar",
        "other": "%{segments} dagen van het jaar"
      },
      "days_on": [
        "zondagen",
        "maandagen",
        "dinsdagen",
        "woensdagen",
        "donderdagen",
        "vrijdagen",
        "zaterdagen"
      ],
      "each_day": {
        "one": "Dagelijks",
        "other": "Elke %{count} dagen"
      },
      "each_hour": {
        "one": "Elk uur",
        "other": "Elke %{count} uren"
      },
      "each_minute": {
        "one": "Elke minuut",
        "other": "Elke %{count} minuten"
      },
      "each_month": {
        "one": "Maandelijks",
        "other": "Elke %{count} maanden"
      },
      "each_second": {
        "one": "Elke seconde",
        "other": "Elke %{count} seconden"
      },
      "each_week": {
        "one": "Wekelijks",
        "other": "Elke %{count} weken"
      },
      "each_year": {
        "one": "Jaarlijks",
        "other": "Elke %{count} jaren"
      },
      "in": "in %{target}",
      "integer": {
        "literal_ordinals": {
          "-1": "laatste",
          "-2": "voorlaatste"
        },
        "negative": "%{ordinal} laatste",
        "ordinal": "%{number}%{ordinal}",
        "ordinals": {
          "default": "e"
        }
      },
      "not": "niet %{target}",
      "not_on": "niet op %{target}",
      "on": "op de  %{sentence}",
      "on_days": "op %{days}",
      "on_minutes_of_hour": {
        "one": "om de %{segments} minuut van het uur",
        "other": "op de %{segments} minuten van het uur"
      },
      "on_seconds_of_minute": {
        "one": "op de %{segments} seconde van de minuut",
        "other": "op de %{segments} seconden van de minuut"
      },
      "on_weekdays": "op weekdagen",
      "on_weekends": "in het weekend",
      "pieces_connector": " / ",
      "string": {
        "format": {
          "count": "%{rest} %{current}",
          "day": "%{rest} %{current}",
          "day_of_month": "%{rest} %{current}",
          "day_of_week": "%{rest} %{current}",
          "day_of_year": "%{rest} %{current}",
          "default": "%{rest} %{current}",
          "hour_of_day": "%{rest} %{current}",
          "minute_of_hour": "%{rest} %{current}",
          "until": "%{rest} %{current}"
        }
      },
      "times": {
        "one": "%{count} keer",
        "other": "%{count} keer"
      },
      "until": "tot %{date}"
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miljard",
            "million": "miljoen",
            "quadrillion": "biljard",
            "thousand": "duizend",
            "trillion": "biljoen",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "byte",
              "other": "bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "pdf": {
      "dossier_export": {
        "attachments_folder": "Bijlagen",
        "dossier_items": {
          "attachment_label": "Bijlage",
          "title": "Dossier"
        },
        "footer": "Dossieroverzicht %{patient_name}",
        "personal_data": "Persoonsgegevens",
        "relationships": "Contactpersonen"
      },
      "invoice": {
        "billing_period": "Facturatieperiode",
        "conditions": "Voorwaarden",
        "credit_note_conditions": "%{original_conditions} Btw terug te storten aan de Staat in de mate waarin zij oorspronkelijk in aftrek werd gebracht.",
        "credit_note_reason": "Reden voor creditering: %{reason}",
        "dossier": "Cliënt",
        "invoice_date": "Factuurdatum",
        "invoice_number": "Factuurnummer",
        "paid": "Voldaan",
        "receiver": "Ontvanger",
        "recognition_number": "Erkenningsnummer",
        "responsible": "Verantwoordelijke",
        "table": {
          "headers": {
            "line_price": "Prijs",
            "line_total_excl": "Prijs (excl. BTW)",
            "line_total_incl": "Prijs",
            "line_total_vat": "BTW",
            "name": "Omschrijving",
            "price": "Prijs (excl. BTW)",
            "quantity": "Aantal",
            "tax_rate": "BTW %",
            "unit": "Eenheid",
            "unit_price": "Prijs / eenheid",
            "vat": "BTW",
            "vat_percentage": "BTW %"
          }
        },
        "title": "Factuur",
        "title_credit_note": "Creditnota",
        "totals_table": {
          "headers": {
            "total": "Totaal",
            "total_vat": "Totale BTW",
            "total_without_vat": "Totaal excl. BTW",
            "vat_percentage": "BTW %"
          }
        },
        "units": {
          "hours": "u",
          "hours_plural": "u",
          "km": "km",
          "km_plural": "km",
          "month": "maand",
          "month_plural": "maanden",
          "piece": "stuk",
          "piece_plural": "stuks",
          "session": "sessie",
          "session_plural": "sessies"
        }
      }
    },
    "superuser": {
      "billing": {
        "tabs": {
          "billing_runs": "Facturatie runs",
          "invoices": "Facturen",
          "subscriptions": "Abonnementen",
          "supplier": "Leverancier"
        }
      },
      "components": {
        "superuser_app": {
          "menu": {
            "billing": "Facturatie",
            "consultation_types": "Consultatie types",
            "health_funds": "Mutualiteiten",
            "offices": "Zorgverleners",
            "users": "Gebruikers"
          }
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " en ",
        "two_words_connector": " en ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "'s ochtends",
      "at": "om",
      "formats": {
        "date": "%-d %b %Y",
        "default": "%a %-d %B %Y om %-H:%M",
        "hour": "%-H:%M",
        "long": "%A %-d %B %Y - %-H:%M",
        "short": "%d %B"
      },
      "pm": "'s middags"
    },
    "titles": {
      "application": "ZorgMee"
    }
  }
}